import { useSelector } from "react-redux";
import { getPhoto, getName, getSessionId, getTableNumber, getCreateResult, clearAction } from "../redux/slices";
import React, { useEffect, useState } from "react";

import { useAppDispatch } from "../redux/hooks";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loading } from "./Loading";
import { trackEvent } from "../utils/analytics";

import "./playerEntryComplete.scss";

export const PlayerEntryComplete: React.FC = () => {
  const nav = useNavigate();
  const name = useSelector(getName);
  const photo = useSelector(getPhoto);
  const dispatch = useAppDispatch();
  const createResult = useSelector(getCreateResult);

  // BEGIN copied link checking
  const [loading, setLoading] = useState<boolean>(true);
  const [searchParams] = useSearchParams();

  let sessionIdParam = searchParams.get("s");
  let tableNumberParam = searchParams.get("t");
  let venueCode = searchParams.get("v");
  const sessionIdRedux = useSelector(getSessionId);
  const tableNumberRedux = useSelector(getTableNumber);

  useEffect(() => {
    if (sessionIdRedux === null || tableNumberRedux === null) {
      nav(`/?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}`);
    }

    if (sessionIdParam !== sessionIdRedux || tableNumberParam !== tableNumberRedux) {
      nav(`/?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}`);
    } else {
      setLoading(false);
    }
  }, [sessionIdParam, tableNumberParam, venueCode, sessionIdRedux, tableNumberRedux, nav]);

  const addfriend = () => {
    trackEvent({
      gaEvent: "click_add_friend",
      clarityEvent: "click_add_friend",
      params: { venue_code: venueCode },
    });
    sessionStorage.removeItem("hasTakenPhoto");
    sessionStorage.removeItem("hasVisitedPhotoPage");
    dispatch(clearAction());
    nav(`/nickname?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}`);
  };

  if (loading) return <Loading />;

  const tableNumberString = createResult?.reason?.replace("SHUFFLEDECK", "");
  const tableNumberResult = parseInt(tableNumberString);
  const isTableSuccess = !isNaN(tableNumberResult);
  const isLobby = createResult?.reason === "LOBBY";

  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/es-logo.svg"} width="110px" alt="Electric Shuffle" />
      </div>
      <div className="contentCard contentCard--complete">
        <div className="completeInner">
          <div className="completeYoureIn">YOU'RE IN!</div>
          {isTableSuccess ? (
            <>
              <div className="completeHeading">ENJOY THE GAME {name}</div>
              <p className="completeSubheading">Come back tomorrow to view your game highlights</p>
            </>
          ) : isLobby ? (
            <div className="completeHeading">
              NOW CHECK IN
              <br />
              ON A TABLE
            </div>
          ) : (
            <div className="completeHeading">
              ENJOY THE GAME
              <br />
              {name}
            </div>
          )}
          <div className="completePhotoWithStars">
            <img className="completeStar star-one" src={"./img/star-two.svg"} alt="" aria-hidden="true" />
            <img className="completeStar star-two" src={"./img/star-three.svg"} alt="" aria-hidden="true" />
            <img className="completeStar star-three" src={"./img/star-one.svg"} alt="" aria-hidden="true" />
            <div className="circlePhotoContainer">
              <img className="circleWebcam" src={photo} alt={name} />
            </div>
          </div>
          <p className="completeFriendText">
            Are you with a friend
            <br />
            who hasn't joined yet?
          </p>
        </div>
      </div>
      <footer className="btn-container">
        <button className="button" onClick={addfriend}>
          ADD A PLAYER
        </button>
      </footer>
    </div>
  );
};
